import React, { Component } from 'react';

export default class MetricsChartMenuItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleOnClick(chartName) {
        if (this.props.onClick != undefined && this.props.add == null) {
            this.props.onClick(chartName);
        }
    }

    render() {

        let addStyle = (this.props.style != undefined ? this.props.style : {});
        let add = this.props.add;

        if (add === null) {
            add = <div className="material-icons metrics-sort-item-add-icon"></div>
            addStyle.opacity = '0';
        }

        return (
            <div onClick={this.handleOnClick.bind(null, this.props.chart)} className="metrics-chart-item-outer">
                <div className="metrics-chart-item-icon material-icons">{this.props.icon}</div>
                <div className="metrics-chart-item-text">{this.props.text}</div>
            </div>
        );
    }
}